// packages block
import { Box, IconButton, InputAdornment, TextField, Typography } from '@mui/material'
import { FC, KeyboardEvent, useContext } from 'react'
// components block
import { CrossIcon } from '../../assets/images'
// others block
import { AppContext } from '../../context/AppContext'
import { ActionType } from '../../context/AppContextReducer'
import { SearchWithSortProps } from '../../interfaceTypes'

export const SearchWithKeypress: FC<SearchWithSortProps> = ({
  searchPlaceholder,
  infoText,
  loading,
  hasMaxWidth = true
}): JSX.Element => {
  const { dispatch: reducerDispatch, searchValue, isLoading } = useContext(AppContext)

  const searchHandler = (value: string) => {
    reducerDispatch({ type: ActionType.SET_SEARCH_VALUE, searchValue: value })
    reducerDispatch({ type: ActionType.SET_CURRENT_PAGE, currentPage: 1 })
  }

  const keyDownSearchHandler = (event: KeyboardEvent<HTMLInputElement>) => {
    const { key } = event

    if (key === 'Enter') {
      reducerDispatch({ type: ActionType.SET_SEARCH_VALUE, searchValue: searchValue })
      reducerDispatch({ type: ActionType.SET_CURRENT_PAGE, currentPage: 1 })
    }
  }

  const clearSearchHandler = () => reducerDispatch({ type: ActionType.SET_SEARCH_VALUE, searchValue: '' })
  const getSearchValue = () => searchValue || ''

  return (
    <Box maxWidth={hasMaxWidth ? 350 : undefined} width="100%">
      <TextField
        label={searchPlaceholder}
        onChange={({ target: { value } }) => {
          searchHandler(value)
        }}
        value={getSearchValue()}
        focused={!!getSearchValue() || false}
        onKeyDown={keyDownSearchHandler}
        disabled={isLoading || loading}
        fullWidth
        size="medium"
        variant="outlined"
        InputProps={{
          endAdornment: searchValue ? (
            <InputAdornment position="end" onClick={clearSearchHandler}>
              <IconButton
                sx={{ p: 0, svg: { maxWidth: '10px' } }}
                onClick={clearSearchHandler}
                aria-label="clear search"
              >
                <CrossIcon />
              </IconButton>
            </InputAdornment>
          ) : undefined
        }}
      />
      {infoText && (
        <Typography variant="caption" color="wardGray" sx={{ display: 'block', mt: 0.5, ml: 0.5 }}>
          {infoText}
        </Typography>
      )}
    </Box>
  )
}
